/* global analytics */
import mainDefaultIP from '../config.js';
import getFromLocalStorage from './getFromLocalStorage.js';



const fetchDataFromAPI = async (url, method, param) => {


    if (typeof analytics !== 'undefined' && analytics.track) {
        analytics.track('zutatool Event', {
            params: "HruType: " + param.HruType +
            " | CPUType: " + param.CPUType +
            " | GPU_Type: " + param.GPU_Type +
            " | Num_CPU: " + param.Num_CPU +
            " | Num_GPU: " + param.Num_GPU +
            " | CPU_Power: " + param.CPU_Power +
            " | Tcase: " + param.Tcase +
            " | username: "+ getFromLocalStorage('uname')
        });

    }

    console.log("param", param);
    try {
        let apiUrl = `${mainDefaultIP}${url}?`;
        for (const key in param) {
            apiUrl += `${key}=${param[key]}&`;
        }

        const token = JSON.parse(localStorage.getItem('zuta'));
        console.log("token", token);
        const requestOptions = {
            method: method,
            headers: {
                'Content-Type': 'application/json',
                'Authorization': 'Bearer ' + token
            }
        };

        if (method !== 'GET') {
            requestOptions.body = JSON.stringify(param);
        }

        const response = await fetch(apiUrl, requestOptions);
        const data = await response.json();

        if(data.error){
            if(data.error.status === 401){
                return {error: "invalid_token", status: data.error.status}
            }

        }


        return data;


    } catch (error) {
        console.error('Error fetching data from API:', error);
    
        // Check if error has a response (e.g., a failed HTTP request)
        let responseText;
        if (error.message) {
            try {
                responseText = await error.message.text(); // Read response as text
                const jsonResponse = JSON.parse(responseText); // Try parsing as JSON
                return jsonResponse; // Return valid JSON
            } catch (jsonError) {
                // If parsing fails, return an error object with the raw response
                return { error: 'invalid_token', message: "Invalid JSON response from server" };
            }
        } else {
            // If it's not an HTTP response (e.g., network error), return a generic error message
            return { error: 'invalid_token', message: error.message || error.toString() };
        }
    }
    
    
};

export { fetchDataFromAPI };
